import { useEffect, useState } from "react";

const links = [
  { href: "#top", label: "首页" },
  { href: "#feed", label: "新鲜盘点" },
  { href: "#topics", label: "反差分类" },
  { href: "#deep", label: "深度观察" },
  { href: "#voices", label: "读者口碑" },
  { href: "#faq", label: "常见问答" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-200/80 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-background-50"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6 py-3 md:py-4" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-radar-fill text-lg" />
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            反差雷达
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#about"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex md:items-center"
          >
            <i className="ri-lightbulb-flash-line mr-1.5 text-base" />
            投稿线索
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-secondary-100 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-secondary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-lightbulb-flash-line mr-1.5 text-base" />
              投稿线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}